import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ResourceData } from '@app/shared/abstract/resource.data';
import { EventRoleName, EventRoleNameRole } from './event-role-name.model';

/**
 * TVG-83: Admin-managed Sales Manager / Show around name lists.
 *
 * The event form reads the active names to populate its dropdowns; the admin
 * management block on the Users page also lists inactive names and creates /
 * renames / deactivates them. The whole feature is gated behind the
 * `event-ownership-fields` toggle (the API 404s when off).
 */
@Injectable({ providedIn: 'root' })
export class EventRoleNameService {
  private readonly baseUrl = `${environment.apiUrl}/api/event-role-names`;

  constructor(private http: HttpClient) {}

  /**
   * List names for a role. Admins may pass includeInactive to also receive the
   * deactivated names (needed for the management block); everyone else always
   * gets the active, selectable names only.
   */
  getByRole(role: EventRoleNameRole, includeInactive = false): Observable<{ data: EventRoleName[] }> {
    let params = new HttpParams().set('role', role);
    if (includeInactive) {
      params = params.set('include_inactive', '1');
    }

    return this.http.get<{ data: EventRoleName[] }>(this.baseUrl, { params });
  }

  create(role: EventRoleNameRole, name: string): Observable<ResourceData<EventRoleName>> {
    return this.http.post<ResourceData<EventRoleName>>(this.baseUrl, { role, name });
  }

  update(id: number, changes: { name?: string; is_active?: boolean }): Observable<ResourceData<EventRoleName>> {
    return this.http.put<ResourceData<EventRoleName>>(`${this.baseUrl}/${id}`, changes);
  }
}
